import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import { json, LinksFunction, LoaderFunctionArgs } from "@remix-run/node";
import { HeroUIProvider } from "@heroui/react";

import stylesheet from "~/tailwind.css?url";
import { Toaster } from "./components/ui/toaster";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: stylesheet },
  {
    rel: "icon",
    href: "/favicon.png",
    type: "image/png",
  },
  {
    rel: "apple-touch-icon",
    href: "/favicon.png",
    type: "image/png",
  },
  {
    rel: "shortcut icon",
    href: "/favicon.png",
    type: "image/png",
  },
];

export function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  return json({
    ENV: {
      NODE_ENV: process.env.NODE_ENV,
      MIRA_ENV:
        process.env.MIRA_ENV ??
        (process.env.NODE_ENV === "production" ? "production" : "development"),
      HOST: url.hostname,
    },
  });
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang={i18n.resolvedLanguage ?? i18n.language} className="h-full">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="h-full">
        <I18nextProvider i18n={i18n}>
          <HeroUIProvider className="h-full" disableAnimation>
            {children}
            <ScrollRestoration />
            <Scripts />
            <Toaster />
          </HeroUIProvider>
        </I18nextProvider>
      </body>
    </html>
  );
}

// export const ErrorBoundary = () => {
//   const error = useRouteError();
//   captureRemixErrorBoundaryError(error);
//   return <div>Something went wrong</div>;
// };

export default function App() {
  return <Outlet />;
}
